import {useSelector} from "react-redux";
import {ReduxState} from "../interface/redux.interface";
import {User, UserModule} from "../interface/user.interface";
import {EFI_MODULES, has_role} from "../util/General";
import {useMemo} from "react";
import {
    ROLE_COTIZADOR_ADMIN,
    ROLE_COTIZADOR_VAM_ADMIN,
    ROLES_COTIZADOR,
    ROLES_COTIZADOR_VAM,
} from "../constants/role-cotizador.constants";

export const useUser = () => {
    const user = useSelector<ReduxState, User>(state => state.user) || {};
    const module = useSelector<ReduxState, UserModule>(state => state.mod) || {};

    return useMemo(() => {
        const isAdmin = has_role(user, "ROLE_ADMIN");
        const isBroker = has_role(user, "ROLE_BROKER");
        const isSubAgente = has_role(user, "ROLE_AGENTE");
        const isEjecutivo = has_role(user, "ROLE_EJECUTIVO");
        const isModuleGen = EFI_MODULES.GEN === module.mod;
        const isModuleVam = EFI_MODULES.VAM === module.mod;
        const isNotPortales = !isAdmin && !isBroker && !user.asociados?.length && !user.asociadosVam?.length;

        const isCotizador = isNotPortales && ROLES_COTIZADOR.includes(user.rolCotizador);
        const isCotizadorAdmin = user.rolCotizador === ROLE_COTIZADOR_ADMIN;

        const isCotizadorVam = isNotPortales && ROLES_COTIZADOR_VAM.includes(user.rolCotizadorVam);
        const isCotizadorVamAdmin = user.rolCotizadorVam === ROLE_COTIZADOR_VAM_ADMIN;

        const result: User = {
            ...user,
            isModuleVam,
            isModuleGen,
            isAdmin,
            isBroker,
            isEjecutivo,
            isSubAgente,
            isCotizador,
            isCotizadorAdmin,
            isCotizadorVam,
            isCotizadorVamAdmin,
            moduleName: module.mod,
            fullName: `${user.nmAsegurado ?? ""} ${user.apAsegurado ?? ""}`,
        };
        return result;
    }, [
        module.mod,
        user.rolWeb,
        user.roles,
        user.apAsegurado,
        user.nmAsegurado,
        user.asociados,
        user.asociadosVam,
        user.rolCotizador,
        user.rolCotizadorVam,
    ]);
};
